export const IS_PROD_ENV = import.meta.env.VITE_VERCEL_ENV === 'production';
export const IS_STAGING_ENV =
  import.meta.env.VITE_VERCEL_ENV_STAGING === 'staging' ||
  import.meta.env.VITE_VERCEL_ENV === 'preview';
export const IS_DEVELOPMENT_ENV =
  import.meta.env.VITE_VERCEL_ENV === 'development' || import.meta.env.DEV;

const getXPlumTokenCookieNameByEnv = () => {
  return !IS_PROD_ENV ? 'x-plum-staging-token' : 'x-plum-prod-token';
};

// add all env varialbes here
const AppConfig = {
  APP_NAME: 'chat-framework',
  TOKEN_ADDED_VIA_EXTERNAL_APPLICATION_EVENT:
    'TOKEN_ADDED_VIA_EXTERNAL_APPLICATION',
  JWT_TOKEN_COOKIE_NAME: getXPlumTokenCookieNameByEnv(),
  LOCAL_STORAGE_JWT_TOKEN_KEY: getXPlumTokenCookieNameByEnv(),
  PLUM_APP_HOST_URL: import.meta.env.VITE_PLUM_APP_HOST_URL,
  SSO_HOST_URL: import.meta.env.VITE_SSO_HOST_URL,
  SERVICE_TOKEN: import.meta.env.VITE_SERVICE_TOKEN,
  SUPPORT_CENTER_BASE_URL: import.meta.env.VITE_SUPPORT_CENTER_BASE_URL,
  NEXT_PUBLIC_PLUM_APP_BASE_URL: import.meta.env.NEXT_PUBLIC_PLUM_APP_BASE_URL,
  BOT_CONTEXT: 'bot-context',
  BOT_INITIAL_QUESTION: 'bot-initial-question',
  FORCE_ANALYTICS_TURN_ON: !!import.meta.env.VITE_FORCE_ANALYTICS_TURN_ON,
  CLEVERTAP_ACCOUNT_ID: import.meta.env.VITE_CLEVERTAP_ACCOUNT_ID,
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
};

export default AppConfig;